<template>
  <b-sidebar
      id="add-sidebar"
      :visible="isAddSidebarActive"
      bg-variant="white"
      sidebar-class="sidebar-lg"
      shadow
      backdrop
      no-header
      right
      @hidden="resetForm"
      @change="(val) => $emit('update:is-add-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Tambah Pegawai Baru
        </h5>

        <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
        >

          <!-- Nama -->
          <validation-provider
              #default="validationContext"
              name="Nama Pegawai"
              rules="required"
          >
            <b-form-group
                label="Nama Pegawai"
                label-for="nama"
            >
              <b-form-input
                  id="nama"
                  v-model="data.nama"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- EMAIL -->
          <validation-provider
              #default="validationContext"
              name="Email"
              rules="required|email"
          >
            <b-form-group
                label="Email"
                label-for="email"
            >
              <b-form-input
                  id="email"
                  v-model="data.email"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Tanggal Lahir -->
          <validation-provider
              #default="validationContext"
              name="Tanggal Lahir"
              rules="required"
          >
            <b-form-group
                label="Tanggal Lahir"
                label-for="tanggal_lahir">
              <flat-pickr
                  id="tanggal_lahir"
                  v-model="data.tanggal_lahir"
                  class="form-control"
                  :config="{enableTime: false}"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Telepon -->
          <validation-provider
              #default="validationContext"
              name="Telepon"
              rules="required"
          >
            <b-form-group
                label="Telepon"
                label-for="telepon"
            >
              <b-form-input
                  id="telepon"
                  v-model="data.telepon"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Bidang -->
          <validation-provider
              #default="validationContext"
              name="Bidang"
              rules=""
          >
            <b-form-group
                label="Bidang"
                label-for="bidang"
                :state="getValidationState(validationContext)"
            >
              <v-select
                  v-model="data.bidang"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="bidangOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="bidang"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Jabatan -->
          <validation-provider
              #default="validationContext"
              name="Jabatan"
              rules="required"
          >
            <b-form-group
                label="Jabatan"
                label-for="jabatan"
            >
              <b-form-input
                  id="jabatan"
                  v-model="data.jabatan"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Pengawas -->
          <validation-provider
              #default="validationContext"
              name="Pengawas"
              rules="required"
          >
            <b-form-group
                label="Pengawas"
                label-for="pengawas"
                :state="getValidationState(validationContext)"
            >
              <v-select
                  v-model="data.pengawas"
                  :disabled="pengawas != null"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="pengawasOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="pengawas"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- UnitKerja -->
          <validation-provider
              #default="validationContext"
              name="Unit Kerja"
              rules="required"
          >
            <b-form-group
                label="Unit Kerja"
                label-for="kategori"
                :state="getValidationState(validationContext)"
            >
              <v-select
                  :disabled="!data.pengawas"
                  v-model="data.unit_kerja"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="unitKerjaOptions"
                  :reduce="val => val.value"
                  :clearable="false"
                  input-id="kategori"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
              #default="validationContext"
              name="Foto"
              rules="required"
          >
            <b-form-group
                label="Foto"
                label-for="foto"
                :state="getValidationState(validationContext)"
            >
              <b-form-file
                  id="foto"
                  accept="image/*"
                  v-model="data.foto"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <img v-if="data.fotoBase64" :src="data.fotoBase64" alt="Foto Profil" class="img-thumbnail">


          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
            >
              Tambah
            </b-button>
            <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
            >
              Batal
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton, BFormTextarea, BFormFile, BImg
} from 'bootstrap-vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {ref} from '@vue/composition-api'
import {required, alphaNum, email} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormTextarea,
    BFormFile,
    BImg,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr

  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-sidebar-active',
  },
  props: {
    isAddSidebarActive: {
      type: Boolean,
      required: true,
    },
    pengawasOptions: {
      type: Array,
      required: true,
    },
    pengawas: {
      type: Object,
      required: false
    },
    bidangOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      required,
      alphaNum,
      unitKerjaOptions: []
    }
  },
  setup(props, {emit}) {
    const blankData = {
      nama: '',
      // nip: '',
      // password: '',
      telepon: '',
      bidang: null,
      tanggal_lahir: null,
      jabatan: null,
      pengawas: props.pengawas ? props.pengawas : null,
      unit_kerja: null,
      foto: null,
      fotoBase64: null,
      email: '',
    }


    for (let [key, value] of props.pengawasOptions) {
      console.log(`${key}: ${value}`);
    }
    const data = ref(JSON.parse(JSON.stringify(blankData)))
    const resetData = () => {
      blankData.pengawas = props.pengawas ? props.pengawas : null
      data.value = JSON.parse(JSON.stringify(blankData))
    }


    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)

    return {
      data,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
  watch: {
    'data.pengawas': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          const dataTMP = []
          for (let key in val.unit_kerja) {
            dataTMP.push({
              'label': val.unit_kerja[key].nama,
              'value': val.unit_kerja[key].id,
            });
          }
          this.unitKerjaOptions = dataTMP
        } else {
          this.unitKerjaOptions = []
        }
        this.data.unit_kerja = null
      }
    },
    'data.foto': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.createBase64Image(val)
        } else {
          self.fotoBase64 = null
        }
      }
    },
    pengawasOptions: {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          if (this.pengawas) {
            let idPengawas = this.pengawas.id;
            let that = this
            val.forEach(function (item, index) {
              if (item.value.id === idPengawas) {
                that.data.pengawas = item.value
              }
            })
          }
        }
      }
    }
  },
  methods: {
    createBase64Image: function (fileObject) {
      const self = this;
      const reader = new FileReader()
      reader.onload = function (e) {
        self.data.fotoBase64 = e.target.result
      }
      reader.readAsDataURL(fileObject);
    },
    onSubmit : async function () {
      const self = this
      await store.dispatch('app-pegawai/add', self.data)
          .then(response => {
            return this.$router.push({name: 'pegawai-detail', params: {id: response.data.data.id}})
          })
    }
  },
  mounted() {

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
